import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';
import { useTariffContext } from '@app/feature/tariff/tariff.context';

export const InformationCardComponent = (): React.JSX.Element => {
  const { t } = useTranslation();

  const tariff = useTariffContext();

  const startDate = useMemo(() => {
    const firstElement = tariff.elements[0];
    if (firstElement) {
      return firstElement.restrictions?.startDate;
    }
    return undefined;
  }, [tariff]);

  const endDate = useMemo(() => {
    const firstElement = tariff.elements[0];
    if (firstElement) {
      return firstElement.restrictions?.endDate;
    }
    return undefined;
  }, [tariff]);

  return (
    <Card gap={GapEnum.M} direction="column">
      <AccentTitle
        icon="info-circle"
        text={t('$.tariff-details.information.title')}
        as={HeadingEnum.H2}
      />

      <Stack gap={GapEnum.M} justifyContent="space-between">
        <Text bold>{t('delmonicos-shared-sdk.outputs-tariff.currency')}</Text>{' '}
        {tariff.currency}
      </Stack>

      <Divider />

      <Stack gap={GapEnum.S} direction="column">
        <Text>{t('$.tariff-details.information.validity.title')}</Text>
        <Stack gap={GapEnum.M} justifyContent="space-between">
          <Stack gap={GapEnum.M} justifyContent="space-between" flex={1}>
            <Text bold>
              {t(
                'delmonicos-shared-sdk.outputs-tariff-restrictions.start-date',
              )}
            </Text>
            {startDate ? formatDate(startDate, i18n) : '-'}
          </Stack>
          <Stack gap={GapEnum.M} justifyContent="space-between" flex={1}>
            <Text bold>
              {t('delmonicos-shared-sdk.outputs-tariff-restrictions.end-date')}
            </Text>
            {endDate ? formatDate(endDate, i18n) : '-'}
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
